import { qyllbPostOrder, qyllbLogin } from '@/api/qyllb'
import { Toast } from 'vant'

let initState = {
  setCityObj: {},
}

let cloneDeep = (data) => {
  //copy一份数据
  return JSON.parse(JSON.stringify(data))
}
const state = cloneDeep(initState)
const mutations = {
  SET_CITYOBJ: (state, setCityObj) => {
    state.setCityObj = setCityObj
  },
  INIT_STATE: (state) => {
    Object.assign(state, initState)
  },
}
const actions = {
  initState({ commit }) {
    commit(`INIT_STATE`)
  },
  setCityObj({ commit }, data) {
    commit(`SET_CITYOBJ`, data)
  },
  async getSDKToken({ dispatch }, formData) {
    let data = {}
    await channelSDK()
      .then((sdkToken) => {
        // dispatch(`getLogin`, { ...formData, sdkToken })
        data = { status: true, data: sdkToken }
      })
      .catch((errmsg) => {
        console.log(`channelSDK报错=====》`, errmsg)
        data = { status: false, data: {} }
      })

    return data
  },
  async getLogin({ dispatch, rootGetters }, { verifyCode, sdkToken, contactNum }) {
    const { status, data, msg } = await qyllbLogin({
      smsCode: verifyCode,
      mobile: contactNum,
      channel: rootGetters.channel, //必填	string	渠道号
      cardType: rootGetters.cardTypes[0].card_type, // 必填	String	卡类型，宽带产品订购
    })
    if (status == 1) {
      return { status: true, data: data.token }
    } else {
      Toast(msg)
      return { status: false, data: {} }
    }
  },
  async onsubmit({ state, commit, rootGetters }, { loginToken, verifyCode, sdkToken, contactNum }) {
    const { status, data, msg } = await qyllbPostOrder({
      ...state.setCityObj,
      channel: rootGetters.channel, //必填	string	渠道号
      cardType: rootGetters.cardTypes[0].card_type, // 必填	String	卡类型，宽带产品订购
      loginToken,
      img: rootGetters.cardTypes[0].top_image_url,
      mediaLink: window.location.href, //必填	string	下单媒体完整链接
      captchaId: verifyCode,
      sdkToken: sdkToken,
      contactNumber: contactNum,
    })
    if (status == 1) {
      //   dispatch(`onsubmit`, { verifyCode, sdkToken, contactNum, loginToken: data.token })
      return { status: true, msg, data }
    } else {
      // Toast(msg)
      return { status: false, msg }
    }
  },
  async onsubmit2({ rootGetters }, { verifyCode, contactNum }) {
    const { status, data, msg } = await qyllbPostOrder({
      channel: rootGetters.channel, //必填	string	渠道号
      cardType:rootGetters.cardTypes[0].card_type, // 必填	String	卡类型，宽带产品订购
      img: rootGetters.cardTypes[0].top_image_url,
      mediaLink: window.location.href, //必填	string	下单媒体完整链接
      captchaId: verifyCode,
      contactNumber: contactNum,
    })
    if (status == 1) {
      //   dispatch(`onsubmit`, { verifyCode, sdkToken, contactNum, loginToken: data.token })
      return { status: true, msg, data }
    } else {
      // Toast(msg)
      return { status: false, msg }
    }
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
